export const getCurrencyPattern = (noHTML, setup) => noHTML
    ? setup.formatPatternNoHTML
    : setup.formatPattern;
